import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getMonitoringStatistics } from '@/service/alerts'

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  data: {}
}

export const fetchMonitoringStatistics = createAsyncThunk(
  'monitoringStatistics/fetchMonitoringStatistics',
  async ({ query = {} }, { rejectWithValue }) => {
    try {
      const response = await getMonitoringStatistics(query)
      return {
        data: response.data,
        query
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.msg || '获取监控预警统计失败')
    }
  }
)

function statisticsBody (data) {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return null
  if (Array.isArray(data.slots)) return data
  const inner = data.data
  if (inner && typeof inner === 'object' && !Array.isArray(inner) && Array.isArray(inner.slots)) {
    return inner
  }
  return null
}

const monitoringStatisticsSlice = createSlice({
  name: 'monitoringStatistics',
  initialState: defaultState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMonitoringStatistics.pending, (state, action) => {
        state.fetching = true
        state.error = null
        state.query = action.meta.arg.query || {}
      })
      .addCase(fetchMonitoringStatistics.fulfilled, (state, action) => {
        state.fetching = false
        state.error = null
        state.data = action.payload.data
        state.query = action.payload.query
      })
      .addCase(fetchMonitoringStatistics.rejected, (state, action) => {
        state.fetching = false
        state.error = action.payload
        state.data = {}
      })
      .addMatcher(
        (action) => action.type === 'sse/addSseMessage',
        (state, action) => {
          const msg = action.payload || {}
          if (msg.type !== 'monitoring_alam_staisies' && msg.type !== 'monitoring_alarm_statistics') return
          const body = statisticsBody(msg.data)
          if (!body) return
          const incomingStore = body.storeId != null && body.storeId !== ''
            ? String(body.storeId)
            : ''
          const currentStore = state.query && state.query.storeId != null && state.query.storeId !== ''
            ? String(state.query.storeId)
            : ''
          if (incomingStore && currentStore && incomingStore !== currentStore) return
          state.error = null
          state.data = {
            timestamp: body.timestamp != null ? body.timestamp : state.data.timestamp,
            slots: body.slots
          }
          if (incomingStore && !currentStore) {
            state.query = { ...state.query, storeId: incomingStore }
          }
        }
      )
  }
})

export default monitoringStatisticsSlice.reducer
